import { useQuery } from "@tanstack/react-query";
import { ProvidersByNetworkData } from "@app/overviews/network-benchmarking-dashboard/tiles/shared";
import { NetworkComparisonFiltersPayload } from "@app/overviews/network-benchmarking-dashboard/filters/network-comparison-filters/shared/NetworkComparisonFiltersPayload";
import { BenchmarkingServiceType } from "@app/overviews/network-benchmarking-dashboard/filters/shared/utility";

export interface ProvidersByNetworkDataResult {
  providersByNetworkData: ProvidersByNetworkData[];
  providersByNetworkDataLoading: boolean;
}

export const PROVIDERS_BY_NETWORK_DATA_QUERY_KEY_PREFIX = "benchmarking-providers-by-network-data";

export const useProvidersByNetworkData = (
  service: BenchmarkingServiceType,
  payload: NetworkComparisonFiltersPayload | null
): ProvidersByNetworkDataResult => {
  const queryResult = useQuery<ProvidersByNetworkData[]>({
    enabled: !!payload,
    queryFn: ({ signal }) => service.getProvidersByNetworkData(payload, signal),
    queryKey: [PROVIDERS_BY_NETWORK_DATA_QUERY_KEY_PREFIX, service?.lineOfBusiness, JSON.stringify(payload)],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    providersByNetworkData: queryResult.data ?? [],
    providersByNetworkDataLoading: queryResult.isFetching,
  };
}

export default useProvidersByNetworkData;
